export default "__VITE_ASSET__DhKSB8E1__"